export const getTxOppositeWalletAccount = (tx, { enabledWalletAccounts, multipleWalletAccountsEnabled, txLogs }) => {
    if (!multipleWalletAccountsEnabled)
        return null;
    if (enabledWalletAccounts.length === 0)
        return null;
    const { data } = tx;
    const transfer = data.transfer;
    const type = data.type;
    const toWalletAccount = data.toWalletAccount;
    const fromWalletAccount = data.fromWalletAccount;
    if (transfer &&
        toWalletAccount &&
        type === 'withdrawal' &&
        enabledWalletAccounts.includes(toWalletAccount)) {
        return toWalletAccount;
    }
    if (transfer &&
        fromWalletAccount &&
        type === 'deposit' &&
        enabledWalletAccounts.includes(fromWalletAccount)) {
        return fromWalletAccount;
    }
    if (!tx.coinName || !tx.txId || !tx.coinAmount)
        return null;
    for (const walletAccount of enabledWalletAccounts) {
        const txSet = txLogs[walletAccount]?.[tx.coinName];
        if (!txSet)
            continue;
        const oppositeTx = txSet.get(tx.txId);
        if (oppositeTx &&
            oppositeTx.sent !== tx.sent &&
            oppositeTx.coinAmount &&
            oppositeTx.coinAmount.abs().equals(tx.coinAmount.abs())) {
            return walletAccount;
        }
    }
    return null;
};
